import axios from "axios";
import qs from "qs";
import { URL } from "../../../constants/Constants";

/**
 * Obtiene el calendario laboral
 * @returns {Promise<Array|null>} Datos del calendario laboral o null si hay error
 */
export const fetchCalendarioLaboral = async () => {
  try {
    const response = await axios.post(
      "https://new.facetbarcelona.com/JTS/php/calendario.php"
    );

    if (response.status === 200 && Array.isArray(response.data)) {
      return response.data;
    } else {
      console.error("Error al obtener el calendario laboral: datos inválidos.");
      return null;
    }
  } catch (error) {
    console.error("Error al conectar con el servidor:", error);
    return null;
  }
};

/**
 * Obtiene logs de asignación
 * @returns {Promise<Array|null>} Datos de logs de asignación o null si hay error
 */
export const fetchAsignacionLog = async () => {
  try {
    const response = await axios.post(
      "https://new.facetbarcelona.com/JTS/php/asignacion.php"
    );

    if (response.status === 200 && Array.isArray(response.data)) {
      return response.data;
    } else {
      console.error("Error al obtener el calendario laboral: datos inválidos.");
      return null;
    }
  } catch (error) {
    console.error("Error al conectar con el servidor:", error);
    return null;
  }
};

/**
 * Obtiene asignaciones por usuario
 * @param {string} query_param - Parámetro de consulta
 * @param {string} queryType - Tipo de consulta
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const fetchAsignacionPorUsuario = async (query_param, queryType) => {
  const queryData = {
    query_param: query_param,
    query_type: queryType,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene asignaciones por usuario finalizadas
 * @param {string} query_param - Parámetro de consulta
 * @param {string} queryType - Tipo de consulta
 * @param {string} fecha - Fecha
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const fetchAsignacionPorUsuarioFinalizadas = async (
  query_param,
  queryType,
  fecha
) => {
  const queryData = {
    query_param: query_param,
    query_type: queryType,
    fecha: fecha,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
